'use strict';
import { Howl } from 'howler';

class SEController extends Howl {
  constructor(path) {
    super({
      src: [path],
      preload: true,
      sprite: {
        NG01: [0, 444.0816326530612],
        bike_pizza2: [2000, 1671.8367346938776],
        bike_pizza_turn3: [5000, 783.6734693877547],
        chatSE01: [7000, 208.97959183673453],
        choice01: [9000, 496.3265306122455],
        coin01: [11000, 391.8367346938769],
        coin02: [13000, 653.0612244897966],
        gu: [15000, 470.20408163265336],
        hint02: [17000, 1410.6122448979584],
        ice_fall_02: [20000, 365.7142857142866],
        ice_seikai: [22000, 1671.8367346938762],
        ice_stamp: [25000, 1384.489795918366],
        jikkou: [28000, 679.1836734693889],
        juuuu: [30000, 1671.8367346938762],
        kansei: [33000, 1671.8367346938762],
        kekkagamen: [36000, 2977.9591836734694],
        kirokukousin: [40000, 3134.6938775510225],
        lost_1: [45000, 313.4693877550987],
        missionclear: [47000, 2011.4285714285743],
        modal_close: [51000, 417.9591836734673],
        modal_open: [53000, 444.08163265305944],
        mogumogu2: [55000, 313.4693877550987],
        nedan_bar: [57000, 130.61224489796075],
        pizza_gu: [59000, 470.2040816326516],
        pizza_pen: [61000, 2298.775510204081],
        proc_SE01: [65000, 496.32653061225085],
        proc_SE02: [67000, 548.5714285714351],
        proc_finish01: [69000, 1044.897959183672],
        proc_start: [72000, 1280.0000000000011],
        robotAnime: [75000, 3761.632653061227],
        sara2: [80000, 313.4693877551058],
        seikai: [82000, 862.0408163265267],
        soldout_3: [84000, 940.4081632653032],
        stamp: [86000, 1227.7551020408168],
        star: [89000, 1384.4897959183697],
        sushi_fall: [92000, 391.83673469388225],
        sushi_start: [94000, 2115.9183673469356],
        taberu: [98000, 992.6530612244875],
        tong: [100000, 3030.2040816326466],
        topping: [105000, 313.4693877551058],
        watasu3: [107000, 705.3061224489738],
        yattemiyou3: [109000, 1097.142857142856],
      },
    });
  }
}

export default SEController;
